module.exports = __webpack_public_path__ + "assets/img/combo_box1.70859872.png";